import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportTreinamentosFuncionariosUseCase } from "../../../presentation/useCases/read/get_report_treinamentos_funcionarios_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportTreinamentosFuncionariosUseCase
 */

export class GetReportTreinamentosFuncionariosUseCase implements IGetReportTreinamentosFuncionariosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportTreinamentosFuncionarios(
    requiredMimeType: ReportMimeType | null,
    centroCustos: number[] | null,
    dataRealizado: (Date | null)[] | null,
    funcionarios: number[] | null,
    dataAvaliacao: (Date | null)[] | null,
    eficaz: number[] | null,
    idUsuario: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportTreinamentosFuncionarios(
      requiredMimeType,
      centroCustos,
      dataRealizado,
      funcionarios,
      dataAvaliacao,
      eficaz,
      idUsuario,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `funcionarios_treinamentos_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
